export { FilterViewManager } from './src/filter-view-manager';
